import React, { Component } from 'react'
import { getUser } from '../../actions/session';
import Axios from 'axios';
import Select from 'react-select';
import { PLUS_ACCOUNT_STATS, TABLE_STATS } from '../../config/rest_endpoints';
import CustomLoader from '../common/loader';
import Container from '../common/application_container'
import DatePicker from "react-datepicker";
import ChangeAccountStats from './changeAccountStatsReport';
import ReactTooltip from 'react-tooltip';
import { fmtDollar4, fmtMins, fmtInt } from '../common/formatters';




export class AccountStatsReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            User: getUser(),
            data: [],
            selectTimeOption: [
                { value: '5m', label: '5-Min' },
                { value: '1h', label: '1-Hour' },
                { value: '12h', label: '12-Hour' }
            ],
            selectTime: { value: '5m', label: '5-Min' },
            isExpend: false,
            newData: [],
            expendId: '',
            isGetting: false,
            isDescOrder: false,
            isAsceOrder: false
        }
        this.onSelectTimeInterval = this.onSelectTimeInterval.bind(this)
        this.handleSortingNumberDesc = this.handleSortingNumberDesc.bind(this)
        this.handleSortingNumberAsce = this.handleSortingNumberAsce.bind(this)
        this.renderYesterday = this.renderYesterday.bind(this)
        this.closeExpand = this.closeExpand.bind(this)
    }

    // componentWillMount() {
    //     this.getTableStats()
    // }

    componentDidMount() {
        // this.interval = setInterval(() => {
        //     this.getTableStats()
        // }, 100000)
        // this.getTableStats()
    }

    // componentWillUnmount() {
    //     clearInterval(this.interval)
    // }

    onSelectTimeInterval(selectTime) {
        this.setState({ selectTime }, () => {
            this.getTableStats()
        })
    }

    getTableStats() {
        const { data, User, selectTime } = this.state
        var interval = selectTime.value;
        this.setState({ isGetting: true })
        var headers = { 'Authorization': "Bearer " + User.token }
        Axios.get(`${TABLE_STATS}/12h`, { headers }).then(res => {
            if (res) {
                var resp = res.data.data
                this.setState({
                    data: resp,
                    isGetting: false
                })
                this.handleSortingNumberAsce()
            }
        })
    }

    renderYesterday(stats, id) {
        this.setState({
            isExpend: true,
            newData: stats,
            expendId: id

        })
    }

    closeExpand() {
        this.setState({
            isExpend: false,
            expendId: -1
        })
    }

    handleSortingName(name) {
        console.log('name :>> ', name);
        const { data } = this.state
        function sortOn(name) {
            return function (a, b) {
                if (a[name].toLowerCase() < b[name].toLowerCase()) {
                    return -1;
                } else if (a[name].toLowerCase() > b[name].toLowerCase()) {
                    return 1;
                } else {
                    return 0;
                }
            }
        }
        data.sort(sortOn(name))
        console.log('data :>> ', data);
        this.setState({ data })
    }

    handleSortingNumberDesc(num) {
        console.log('num :>> ', num);
        const { data } = this.state
        data.sort((a, b) => parseInt(a[num]) - parseInt(b[num])).reverse()
        this.setState({ data, isDescOrder: true, isAsceOrder: false })
        console.log('int', data)
    }

    handleSortingNumberAsce(num) {
        console.log('num :>> ', num);
        const { data } = this.state
        data.sort((a, b) => parseInt(a[num]) - parseInt(b[num]))
        this.setState({ data, isAsceOrder: true, isDescOrder: false })
        console.log('int', data)
    }

    __renderTable_Stats() {
        const { data, expendId } = this.state

        if (data == undefined || data.length <= 0) {
            return (
                <td colSpan="7" >
                    <p>Nothing to show</p>
                </td>
            )
        }
        else {
            return data.map((stats, idx) => {

                return (
                    <>
                        <tr key={idx} className="left_align">
                            <td><i className="icon-plus-circle2 mr-3 icon-1x" onClick={this.renderYesterday.bind(this, stats, idx)}></i></td>
                            <td><span className="badge bg-blue fs-12">{stats['accountName']}</span></td>
                            {/* <td><span className="text-success-600"><i className="icon-stats-growth2 mr-1"></i></span>{stats['sessions']}</td> */}
                            {/* <td><span className="text-success-600"><i className="icon-stats-growth2 mr-1"></i></span>{stats['cps']}</td> */}
                            <td style={{textAlign:'right'}}>{stats['ansSeizeRatio'] === 0 ? <> <span className="text-warning-600"><i className="icon-menu-close2 mr-1"></i></span> {stats['ansSeizeRatio']}</> : <> <span className="text-success-600"><i className="icon-menu-close2 mr-1"></i></span> {stats['ansSeizeRatio']}</>}</td>
                            <td style={{textAlign:'right'}}><span className="text-success-600"><i className="icon-history mr-1"></i></span> {stats['avgCallDur']}</td>
                            <td style={{textAlign:'right'}}><span className="text-success-600"><i className="icon-history mr-1"></i></span>{fmtMins(stats['totalCallDuration'])}</td>
                            <td style={{textAlign:'right'}}><span className="text-success-600"><i className="icon-price-tags mr-1"></i></span> {fmtMins(stats['billedCallDuration'])}</td>
                            <td style={{textAlign:'right'}}><span className="text-success-600"><i className="icon-split mr-1"></i></span>{fmtInt(stats['duplicateNum'])}</td>
                            <td style={{textAlign:'right'}}><span className="text-success-600"><i className="icon-phone2 mr-1"></i></span>{fmtInt(stats['totalSuccessfulCalls'])}</td>
                            {/* <td><span className="text-success-600"><i className="icon-feed mr-1"></i></span>{stats['distinctDstCnt']}</td> */}
                            <td style={{textAlign:'right'}}><span className="text-success-600"><i className="icon-phone-outgoing mr-1"></i></span>{fmtInt(stats['totalDialedCalls'])}</td>
                            <td style={{textAlign:'right'}}><span className="text-success-600"><i className="icon-coin-dollar mr-1"></i></span>{fmtDollar4(stats['avgCallCost'])}</td>
                            <td style={{textAlign:'right'}}><span className="text-success-600"><i className="icon-coin-dollar mr-1"></i></span>{fmtDollar4(stats['totalCallCost'])}</td>
                        </tr>
                        {expendId === idx ?
                            <tr className="left_align">
                                <td><i className="icon-minus-circle2 mr-3 icon-1x" onClick={this.closeExpand}></i></td>
                                <td><span className="badge bg-warning fs-12">{stats['accountName']}</span></td>
                                {/* <td><span className="text-warning-600"><i className="icon-stats-growth2 mr-1"></i></span>{stats['sessions']}</td> */}
                                {/* <td><span className="text-warning-600"><i className="icon-stats-growth2 mr-1"></i></span>{stats['cps']}</td> */}
                                <td style={{textAlign:'right'}}><span className="text-warning-600"><i className="icon-menu-close2 mr-1"></i></span>{stats['ytdAnsSeizeRatio']}</td>
                                <td style={{textAlign:'right'}}><span className="text-warning-600"><i className="icon-history mr-1"></i> </span>{stats['ytdAVGCallDur']}</td>
                                <td style={{textAlign:'right'}}><span className="text-warning-600"><i className="icon-history mr-1"></i></span>{fmtMins(stats['ytdTotalCallDuration'])}</td>
                                <td style={{textAlign:'right'}}><span className="text-warning-600"><i className="icon-price-tags mr-1"></i></span>{fmtMins(stats['ytdBilledCallDuration'])}</td>
                                <td style={{textAlign:'right'}}><span className="text-warning-600"><i className="icon-split mr-1"></i></span>{fmtInt(stats['ytdDuplicateNum'])}</td>
                                <td style={{textAlign:'right'}}><span className="text-warning-600"><i className="icon-phone2 mr-1"></i></span>{fmtInt(stats['ytdTotalSuccessfulCalls'])}</td>
                                {/* <td><span className="text-warning-600"><i className="icon-feed mr-1"></i></span>{stats['ytdDistinctDstCnt']}</td> */}
                                <td style={{textAlign:'right'}}><span className="text-warning-600"><i className="icon-phone-outgoing mr-1"></i></span>{fmtInt(stats['ytdTotalDialedCalls'])}</td>
                                <td style={{textAlign:'right'}}><span className="text-warning-600"><i className="icon-coin-dollar mr-1"></i></span>{fmtDollar4(stats['ytdCallCost'])}</td>
                                <td style={{textAlign:'right'}}><span className="text-warning-600"><i className="icon-coin-dollar mr-1"></i></span>{fmtDollar4(stats['ytdTotalCallCost'])}</td>
                            </tr>
                            : ''}
                    </>
                )
            })
        }
    }

    

    render() {
        const { selectTime, selectTimeOption, isGetting, isDescOrder, isAsceOrder } = this.state
        return (
            <Container title="Account" title1='Stats' icon="fa fa-bars">
                <div style={{border:'1px solid #E2E8F0',borderRadius:'16px',background:'#FFFFFF',boxShadow:'0 1px 3px rgba(0,0,0,0.04)',overflow:'hidden'}}>
                    <div style={{padding:'20px'}}>
                        <ChangeAccountStats/>
                    </div>
                </div>
                <ReactTooltip type="dark" backgroundColor='#0F172A' place='top' effect="solid" />
            </Container>
        )
    }
}

export default AccountStatsReport
